import React from "react";
import { Center, Spinner as ChakraSpinner } from "@chakra-ui/react";

const Spinner = () => (
  <Center height="80vh">
    <ChakraSpinner color="red" size="lg" />
  </Center>
);

export default Spinner;
